import { Col as AntCol } from 'antd'
import AntText from 'antd/lib/typography/Text'
import styled, { css } from 'styled-components'

import { NodeColor } from 'src/components/Tree/Nodes'

export const Col = styled(AntCol)`
  display: flex;
`

const Icon = css`
  border: 1px solid black;
  height: 1rem;
  margin-right: 0.5rem;
  width: 1rem;
`

export const Icon1 = styled.div`
  ${Icon} background-color: ${NodeColor.DISABLED};
`

export const Icon2 = styled.div`
  ${Icon} background-color: ${NodeColor.SELECTED};
`

export const Icon3 = styled.div`
  ${Icon} background-color: ${NodeColor.DEFAULT};
`

export const SelectedRule = styled(AntText)`
  font-size: larger;
  font-style: italic;
  font-weight: bold;
  padding: 0 1rem;
`

export const Text = styled(AntText)`
  font-style: bold;
`

export const Title = styled(AntText)`
  font-size: medium;
  font-weight: bold;
`
